import React from 'react';
import { ReactComponent as GearIcon } from '@base/assets/images/gear.svg';
import LanguagePicker from './languagePicker';
import SoundControl from './soundControl';
import { ReactComponent as SoundIcon } from '@base/assets/images/sound.svg';
import { ReactComponent as LanguageIcon } from '@base/assets/images/globe.svg';
import { ReactComponent as LayoutIcon } from '@base/assets/images/layout.svg';
import LayoutControl from './layoutControl';
import { t } from '@base/utils/helpers';
import styles from '../styles/preferences.module.scss';
import Tabs, { TabPane } from '@ui-kit/components/tabs';
import { IGameProvider } from '@base/features/game/model/interfaces';
import { container } from 'tsyringe';
import { IModalProvider, ModalObservable } from '@base/features/modal/model/interfaces';
import GameControl from './gameControl';

function preferencesModal(): ModalObservable {
  const gameProvider: IGameProvider = container.resolve('gameProvider');
  const modalProvder: IModalProvider = container.resolve('modalProvider');

  const basePrefs = [
    {
      title: 'layout',
      icon: <LayoutIcon />,
      content: <LayoutControl />,
    },
    {
      title: 'sound',
      icon: <SoundIcon />,
      content: <SoundControl />,
    },
    {
      title: 'language',
      icon: <LanguageIcon />,
      content: <LanguagePicker />,
    },
    {
      title: 'game_control',
      icon: <GearIcon />,
      content: <GameControl additionalPreferences={gameProvider.getGamePreferences()} />,
    },
  ];

  const additionalPreferences = gameProvider.getAdditionalPreferences();
  const tabs = additionalPreferences ? basePrefs.concat(additionalPreferences) : basePrefs;

  return {
    title: t('preferences'),
    classes: {
      body: styles.body,
      title: styles.title,
    },
    buttons: [{ title: t('save'), onClick: () => modalProvder.hide() }],
    body: (
      <Tabs className="modalTabs">
        {tabs.map((tab, i) => (
          <TabPane
            label={
              <span className={styles.label}>
                {t(tab.title)}
                {tab.icon}
              </span>
            }
            key={i + 1}
            className={styles.tab}
          >
            {tab.content}
          </TabPane>
        ))}
      </Tabs>
    ),
  };
}

export default preferencesModal;
